import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import { DropdownItem, Row, Col, Label, Form, FormGroup, CustomInput } from 'reactstrap'
import styled from 'styled-components'
import { get, find, set } from 'lodash'
import { FaRegEdit } from 'react-icons/fa'
import { AiOutlineSave } from 'react-icons/ai'

import { SearchSelect, MultipleSearchSelect, Input, TextArea } from '../../../input'
import { CustomDatePicker } from '../../../datepicker'
import moment from '../../../../lib/moment.js'
import left_arrow from '../../../../static/images/left-arrow.svg'
import { FONTS } from '../../../../constants'
import { selectStatusColor, selectStatusWord } from '../../../../function'
import { authSelector } from '../../../../selectors'
import * as projectHelper from '../../helper/project'
import * as CONSTANTS from '../../constants'
import { Button } from '../../../buttons'

class ProjectInformationTable extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'projectByID')
    && get(nextProps, 'users')
    && JSON.stringify(get(nextProps, 'projectByID')) !== JSON.stringify(prevState.projectByID)
    ) {
      const projectByID = get(nextProps, 'projectByID')
      const users = get(nextProps, 'users', [])
      const clients = get(nextProps, 'clients', [])
      const companys = get(nextProps, 'companys', [])
      const lobs = get(nextProps, 'lobs', [])
      const departments = get(nextProps, 'departments', [])
      const approverList = projectHelper.createProjectApproverList(users)
      const supervisorList = projectHelper.createPMSupervisorList(users)
      const managersList = projectHelper.createProjectManagerList(users)
      const last_submit_request = get(nextProps, 'last_submit_request')
      const approvers = []
      const managers = []
      projectByID.project_approver_ids.forEach(p => {
        const apr = find(approverList, { _id: p })
        if (apr !== undefined) approvers.push(apr)
      })
      projectByID.project_manager_ids.forEach(m => {
        const mgr = find(managersList, { _id: m })
        if (mgr !== undefined) managers.push(mgr)
      })
      const company = find(companys, { _id: projectByID.company_id })
      if (company) {
        set(tempState, 'company_id', company._id)
      }
      const lob = find(lobs, { _id: projectByID.lob_id })
      if (lob) {
        set(tempState, 'lob_id', lob._id)
      }
      const department = find(departments, { _id: projectByID.department_id })
      if (department) {
        set(tempState, 'department_id', department._id)
      }
      const client = find(clients, { _id: projectByID.client_id })
      if (client) {
        set(tempState, 'client', client)
      }
      const pm_supervisor = find(supervisorList, { _id: projectByID.project_supervisor_id })
      if (pm_supervisor) {
        set(tempState, 'pm_supervisor', pm_supervisor)
      }
      const key_project_manager = managers.find(m => m._id === get(projectByID, 'key_project_manager_id')) || null
      const updated_by = find(users, { _id: projectByID.updated_by })
      set(tempState, 'updated_by', updated_by)
      set(tempState, 'updated', projectByID.updated)
      const created_by = find(users, { _id: projectByID.created_by })
      set(tempState, 'created_by', created_by)
      set(tempState, 'created', projectByID.created)
      set(tempState, 'project_approvers', approvers)
      set(tempState, 'project_managers', managers)
      set(tempState, 'key_project_manager', key_project_manager)
      set(tempState, 'approvers', approverList)
      set(tempState, 'managers', managersList)
      set(tempState, 'pm_supervisors', supervisorList)
      set(tempState, 'clients', clients)
      set(tempState, 'users', users)
      set(tempState, 'companys', companys)
      set(tempState, 'lobs', lobs)
      set(tempState, 'departments', departments)
      set(tempState, 'project_status', projectByID.project_status)
      set(tempState, 'project_type', projectByID.project_type)
      set(tempState, 'project_name', projectByID.name)
      set(tempState, 'project_code', projectByID.project_code)
      set(tempState, 'project_qt_number', projectByID.qt_number)
      set(tempState, 'description', projectByID.description)
      set(tempState, 'start_date', moment(projectByID.start_date))
      set(tempState, 'end_date', moment(projectByID.end_date))
      set(tempState, 'display_on_resource_utilization', projectByID.display_on_resource_utilization)
      set(tempState, 'last_submit_request', last_submit_request)
      set(tempState, 'projectByID', projectByID)
    }
    return tempState
  }

  state = {
    id: '',
    collapse_overall: false,
    managers: [],
    approvers: [],
    clients: [],
    pm_supervisors: [],
    users: [],
    companys: [],
    lobs: [],
    departments: [],
    company_id: '',
    lob_id: '',
    department_id: '',
    project_managers: [],
    project_approvers: [],
    project_status: '',
    client: '',
    pm_supervisor: '',
    project_qt_number: '',
    project_code: '',
    project_name: '',
    project_number: '',
    description: '',
    created: '',
    created_by: '',
    updated: '',
    updated_by: '',
    startDate: moment(),
    endDate: moment(),
    display_on_resource_utilization: false,
    last_submit_request: {},
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextState) === JSON.stringify(this.state)
    && JSON.stringify(nextProps) === JSON.stringify(this.props)) return false
    return true
  }

  handleProjectManager = e => {
    const { key_project_manager } = this.state
    const keyPM = key_project_manager ? e.find(pm => pm.value === key_project_manager.value) : null
    if (!keyPM) this.setState({ project_managers: e, key_project_manager: null })
    else this.setState({ project_managers: e })
  }

  render() {
    const {
      managers,
      approvers,
      clients,
      pm_supervisors,
      users,
      companys,
      lobs,
      departments,
      company_id,
      lob_id,
      department_id,
      project_managers,
      project_approvers,
      key_project_manager,
      project_status,
      client,
      pm_supervisor,
      project_qt_number,
      project_code,
      project_name,
      project_number,
      description,
      created,
      created_by,
      updated,
      updated_by,
      display_on_resource_utilization,
      last_submit_request,
    } = this.state
    const activeToggle = get(this.props, 'activeToggle')
    const projectByID = get(this.props, 'projectByID')
    const projectType = get(projectByID, 'project_type')
    const rSelected = get(this.props, 'rSelected')
    const editProjectInfo = get(this.props, 'editProjectInfo')
    const project_type = get(projectByID, 'project_type')
    const $canEdit = get(projectByID, '$can_edit')
    const isProjectApprover = get(this.props, 'authData.user.is_project_approver_role')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot') || false
    const isPresale = presale_snapshot && rSelected === 1
    const canApproverOrReject =
    get(projectByID, 'project_approve_status') === CONSTANTS.PENDING && isProjectApprover
    let canEdit
    if (presale_snapshot) {
      canEdit = $canEdit && rSelected === 2
    } else {
      canEdit = $canEdit
    }
    const start_date = isPresale ? presale_snapshot.start_date : this.state.start_date
    const end_date = isPresale ? presale_snapshot.end_date : this.state.end_date

    const project_managers_presale = []
    const project_approvers_presale = []
    let pm_supervisor_presale = null
    let key_pm_presale = null
    let client_presale = null
    let updated_by_presale = null
    const type = get(find(CONSTANTS.project_type, {
      value: project_type,
    }), 'label', '-')

    if (presale_snapshot && isPresale) {
      presale_snapshot.project_manager_ids.forEach(m => {
        const mgr = find(managers, { _id: m })
        if (mgr) project_managers_presale.push(mgr)
      })
      presale_snapshot.project_approver_ids.forEach(a => {
        const apr = find(approvers, { _id: a })
        if (apr) project_approvers_presale.push(apr)
      })
      key_pm_presale = managers.find(m => m._id === presale_snapshot.key_project_manager_id) || null

      const tempClient = find(clients, { _id: presale_snapshot.client_id })
      if (tempClient) client_presale = tempClient

      const temp_pm_supervisor = find(pm_supervisors,
        { _id: presale_snapshot.project_supervisor_id })
      if (temp_pm_supervisor) pm_supervisor_presale = temp_pm_supervisor

      const employee = find(users, { _id: presale_snapshot.updated_by })
      if (employee) updated_by_presale = employee
    }

    const companysOptions = [...companys]
    let lobsOptions = [...lobs]
    let departmentsOptions = [...departments]

    if (presale_snapshot && isPresale) {
      // filter LOB
      if (presale_snapshot.company_id !== '' && lobs) {
        lobsOptions = lobs.filter((element) => {
          return element.company_id === presale_snapshot.company_id
        })
        lobsOptions = [...lobsOptions]
      } else lobsOptions = []
      // filter Department
      if (presale_snapshot.lob_id !== '' && departments) {
        departmentsOptions = departments.filter((element) => {
          return element.lob_id === presale_snapshot.lob_id
        })
        departmentsOptions = [...departmentsOptions]
      } else departmentsOptions = []
    } else {
      // filter LOB
      if (company_id !== '' && lobs) {
        lobsOptions = lobs.filter((element) => {
          return element.company_id === company_id
        })
        lobsOptions = [...lobsOptions]
      } else lobsOptions = []
      // filter Department
      if (lob_id !== '' && departments) {
        departmentsOptions = departments.filter((element) => {
          return element.lob_id === lob_id
        })
        departmentsOptions = [...departmentsOptions]
      } else departmentsOptions = []
    }

    // filter managers and approvers (should not be the same person)
    const managersOptions = managers.filter(manager => {
      const found = find(project_approvers, { _id: manager._id })
      if (!found) return manager
      return null
    })
    const approversOptions = approvers.filter(approver => {
      const found = find(project_managers, { _id: approver._id })
      if (!found) return approver
      return null
    })

    let company = companysOptions.find(c => c._id === (!isPresale ? company_id : get(presale_snapshot, 'company_id')))
    company = company ? { label: company.name, value: company._id } : null
    let lob = lobsOptions.find(l => l._id === (!isPresale ? lob_id : get(presale_snapshot, 'lob_id')))
    lob = lob ? { label: lob.name, value: lob._id } : null
    let department = departmentsOptions.find(d => d._id === (!isPresale ? department_id : get(presale_snapshot, 'department_id')))
    department = department ? { label: department.name, value: department._id } : null

    // const invalid = project_managers.length === 0
    // || !key_project_manager
    // || client === ''
    // || project_name === ''
    // || !company
    // || !lob
    // || !start_date
    // || !end_date

    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <Header onClick={ () => this.setState({ collapse_overall: !this.state.collapse_overall }) }>
          <Icon
            style={ { transform: this.state.collapse_overall ? 'rotate(180deg)' : 'rotate(270deg)' } }
            src={ left_arrow }
            collapse={ !this.state.collapse_overall }
          />
          Project Information
        </Header>
        <div style={ { display: this.state.collapse_overall ? 'none' : 'block' } }>
          <Row>
            <Col sm="12">
              <Form onSubmit={ (e) => e.preventDefault() }>
                <FormGroup>
                  <Container>
                    <RowWrapper>
                      <LabelWrapper required>Project Manager</LabelWrapper>
                      <FlexWrapper flex={ 5 }>
                        <MultipleSearchSelect
                          invalid={ project_managers.length === 0 }
                          name='project_managers'
                          isDisabled={ !editProjectInfo || isPresale }
                          value={ !isPresale ? project_managers : project_managers_presale }
                          options={ managersOptions }
                          onChange={ this.handleProjectManager }
                        />
                      </FlexWrapper>
                    </RowWrapper>
                    <RowWrapper>
                      <LabelWrapper required>Key PM</LabelWrapper>
                      <FlexWrapper flex={ 5 }>
                        <SearchSelect
                          invalid={ !key_project_manager && editProjectInfo }
                          name='key_project_manager'
                          isDisabled={ !editProjectInfo || isPresale }
                          value={ !isPresale ? key_project_manager : key_pm_presale }
                          options={ !isPresale ? project_managers : project_managers_presale }
                          onChange={ e => this.setState({ key_project_manager: e }) }
                        />
                      </FlexWrapper>
                    </RowWrapper>
                    <RowWrapper>
                      <LabelWrapper>Additional Approver</LabelWrapper>
                      <FlexWrapper flex={ 5 }>
                        <MultipleSearchSelect
                          name='project_approvers'
                          isDisabled={ !editProjectInfo || isPresale }
                          value={ !isPresale ? project_approvers : project_approvers_presale }
                          options={ approversOptions }
                          onChange={ e => this.setState({ project_approvers: e }) }
                        />
                      </FlexWrapper>
                    </RowWrapper>
                    <RowWrapper>
                      <FlexWrapper required>Project Type</FlexWrapper>
                      <FlexWrapper>
                        <TextInfo>{ type }</TextInfo>
                      </FlexWrapper>
                      <FlexWrapper>
                        <DropdownLabel>Project Status</DropdownLabel>
                      </FlexWrapper>
                      <FlexWrapper>
                        <TextInfo style={ { color: selectStatusColor(project_status) } }>
                          { selectStatusWord(project_status) }
                        </TextInfo>
                      </FlexWrapper>
                      <FlexWrapper>
                        { projectType === CONSTANTS.COMMON &&
                        <DropdownLabel>Display on Resource Utilization</DropdownLabel>
                        }
                      </FlexWrapper>
                      <FlexWrapper>
                        { projectType === CONSTANTS.COMMON &&
                        <CustomInputField
                          type='checkbox'
                          id='display_on_resource_utilization'
                          name='display_on_resource_utilization'
                          disabled={ !editProjectInfo || isPresale }
                          checked={ display_on_resource_utilization }
                          onChange={ (e) => this.setState({ [e.target.name]: e.target.checked }) }
                        />
                        }
                      </FlexWrapper>
                    </RowWrapper>
                    <RowWrapper>
                      <LabelWrapper required>Client</LabelWrapper>
                      <FlexWrapper flex={ 5 }>
                        <SearchSelect
                          invalid={ client === '' && editProjectInfo }
                          name='client'
                          isDisabled={ !editProjectInfo || isPresale }
                          value={ !isPresale ? client : client_presale }
                          options={ clients }
                          onChange={ e => this.setState({ client: e }) }
                        />
                      </FlexWrapper>
                    </RowWrapper>
                    <RowWrapper>
                      <LabelWrapper>QT/PO No.</LabelWrapper>
                      <FlexWrapper flex={ 5 }>
                        <Input
                          name='project_qt_number'
                          placeholder='Enter QT/PO No.'
                          disabled={ !editProjectInfo || isPresale }
                          defaultValue={ !isPresale ? project_qt_number : get(presale_snapshot, 'qt_number') }
                          onBlur={ (e) => this.setState({ project_qt_number: e.target.value }) }
                        />
                      </FlexWrapper>
                    </RowWrapper>
                    <RowWrapper>
                      <LabelWrapper>Project Number</LabelWrapper>
                      <FlexWrapper flex={ 5 }>
                        <TextInfo>{ project_number || '-' }</TextInfo>
                      </FlexWrapper>
                    </RowWrapper>
                    <RowWrapper>
                      <LabelWrapper>Project Code</LabelWrapper>
                      <FlexWrapper flex={ 5 }>
                        <Input
                          name='project_code'
                          placeholder='Enter Project Code'
                          disabled={ true }
                          defaultValue={ !isPresale ? project_code : get(presale_snapshot, 'project_code') }
                        />
                      </FlexWrapper>
                    </RowWrapper>
                    <RowWrapper>
                      <LabelWrapper required>Project Name</LabelWrapper>
                      <FlexWrapper flex={ 5 }>
                        <Input
                          invalid={ project_name === '' && editProjectInfo }
                          name='project_name'
                          placeholder='Enter Project Name'
                          disabled={ !editProjectInfo || isPresale }
                          defaultValue={ !isPresale ? project_name : get(presale_snapshot, 'name') }
                          onBlur={ (e) => this.setState({ project_name: e.target.value }) }
                        />
                      </FlexWrapper>
                    </RowWrapper>
                    <RowWrapper>
                      <LabelWrapper>PM Supervisor</LabelWrapper>
                      <FlexWrapper flex={ 5 }>
                        <SearchSelect
                          name='pm_supervisor'
                          isDisabled={ !editProjectInfo || isPresale }
                          options={ pm_supervisors }
                          value={ !isPresale ? pm_supervisor : pm_supervisor_presale }
                          onChange={ (e) => this.setState({ pm_supervisor: e }) }
                        />
                      </FlexWrapper>
                    </RowWrapper>
                    <DropdownItem divider />
                    <RowWrapper>
                      <FlexWrapper>
                        <LabelWrapper required>Company</LabelWrapper>
                      </FlexWrapper>
                      <FlexWrapper>
                        <SearchSelect
                          name='company_id'
                          placeholder='Enter Company'
                          invalid={ company_id === '' }
                          isDisabled={ !editProjectInfo || isPresale }
                          options={ companysOptions.map(c => { return { label: c.name, value: c._id } }) }
                          value={ company }
                          onChange={ (e) => this.setState({
                            company_id: e.value,
                            lob_id: '',
                          }) }
                        />
                      </FlexWrapper>
                      <FlexWrapper>
                        <DropdownLabel>
                          <CenterLabelWrapper required>LOB</CenterLabelWrapper>
                        </DropdownLabel>
                      </FlexWrapper>
                      <FlexWrapper>
                        <SearchSelect
                          name='lob_id'
                          placeholder='Enter LOB'
                          invalid={ lob_id === '' }
                          isDisabled={ !editProjectInfo || isPresale }
                          options={ lobsOptions.map(l => { return { label: l.name, value: l._id } }) }
                          value={ lob }
                          onChange={ (e) => this.setState({
                            lob_id: e.value,
                            department_id: '',
                          }) }
                        />
                      </FlexWrapper>
                      <FlexWrapper>
                        <DropdownLabel>Department</DropdownLabel>
                      </FlexWrapper>
                      <FlexWrapper>
                        <SearchSelect
                          name='department_id'
                          placeholder='Enter Department'
                          isDisabled={ !editProjectInfo || isPresale }
                          options={ departmentsOptions.map(d => { return { label: d.name, value: d._id } }) }
                          value={ department }
                          onChange={ (e) => this.setState({ department_id: e.value }) }
                        />
                      </FlexWrapper>
                    </RowWrapper>
                    <DropdownItem divider />
                    <RowWrapper>
                      <FlexWrapper>
                        <DropdownWrapper>
                          <LabelWrapper required>Starts On</LabelWrapper>
                        </DropdownWrapper>
                      </FlexWrapper>
                      <FlexWrapper>
                        <CustomDatePicker
                          showYearDropdown
                          showMonthDropdown
                          autoComplete='off'
                          name='start_date'
                          dateFormat='DD/MM/YYYY'
                          invalid={ !start_date }
                          disabled={ !editProjectInfo || isPresale }
                          selected={ !isPresale ? start_date : moment(get(presale_snapshot, 'start_date')) }
                          onChange={ (e) => this.setState({ start_date: e }) }
                        />
                      </FlexWrapper>
                      <FlexWrapper>
                        <DropdownLabel>
                          <CenterLabelWrapper required>Ends On</CenterLabelWrapper>
                        </DropdownLabel>
                      </FlexWrapper>
                      <FlexWrapper>
                        <CustomDatePicker
                          showYearDropdown
                          showMonthDropdown
                          autoComplete='off'
                          name='end_date'
                          dateFormat='DD/MM/YYYY'
                          invalid={ !end_date }
                          disabled={ !editProjectInfo || isPresale }
                          selected={ !isPresale ? end_date : moment(get(presale_snapshot, 'end_date')) }
                          onChange={ (e) => this.setState({ end_date: e }) }
                        />
                      </FlexWrapper>
                      <FlexWrapper />
                      <FlexWrapper />
                    </RowWrapper>
                    <RowWrapper>
                      <LabelWrapper>Description</LabelWrapper>
                      <FlexWrapper flex={ 5 }>
                        <TextArea
                          name='description'
                          placeholder='Enter Description'
                          maxlength={ 500 }
                          disabled={ !editProjectInfo || isPresale }
                          value={ !isPresale ? description : get(presale_snapshot, 'description') }
                          onChange={ (e) => this.setState({ description: e.target.value }) }
                        />
                      </FlexWrapper>
                    </RowWrapper>
                    <RowWrapper>
                      <FlexWrapper>
                        <DropdownWrapper>Created by</DropdownWrapper>
                      </FlexWrapper>
                      <FlexWrapper>
                        <TextInfo>
                          {`${get(created_by, 'first_name', '')} ${get(created_by, 'last_name', '')}`}
                        </TextInfo>
                      </FlexWrapper>
                      <FlexWrapper>
                        <DropdownLabel>Created Date</DropdownLabel>
                      </FlexWrapper>
                      <FlexWrapper>
                        <TextInfo>
                          { moment(created).format('DD/MM/YYYY HH:mm') }
                        </TextInfo>
                      </FlexWrapper>
                      <FlexWrapper />
                      <FlexWrapper />
                    </RowWrapper>
                    <RowWrapper>
                      <FlexWrapper>
                        <DropdownWrapper>Modified by</DropdownWrapper>
                      </FlexWrapper>
                      <FlexWrapper>
                        <TextInfo>
                          { !isPresale ?
                            `${get(updated_by, 'first_name', '')} ${get(updated_by, 'last_name', '')}` :
                            `${get(updated_by_presale, 'first_name', '')} ${get(updated_by_presale, 'last_name', '')}`
                          }
                        </TextInfo>
                      </FlexWrapper>
                      <FlexWrapper>
                        <DropdownLabel>Modified</DropdownLabel>
                      </FlexWrapper>
                      <FlexWrapper>
                        <TextInfo>
                          { !isPresale ? moment(updated).format('DD/MM/YYYY HH:mm') : moment(get(presale_snapshot, 'updated')).format('DD/MM/YYYY HH:mm') }
                        </TextInfo>
                      </FlexWrapper>
                      <FlexWrapper />
                      <FlexWrapper />
                    </RowWrapper>
                    <DropdownItem divider />
                    { get(last_submit_request, 'remark_request_user') &&
                      <Row style={ { marginTop: 10, backgroundColor: '#EBEBEB', marginLeft: '-10px', marginRight: '-10px' } }>
                        <ColLabel sm={ 2 }>
                          <Label>{ `PM's Remark` }</Label>
                        </ColLabel>
                        <ColRemark sm={ 9 }>
                          <TextInfo>{get(last_submit_request, 'remark_request_user')}</TextInfo>
                        </ColRemark >
                      </Row>
                    }
                    { get(last_submit_request, 'remark_approver') &&
                      <Row style={ { marginTop: 10, backgroundColor: '#EBEBEB', marginLeft: '-10px', marginRight: '-10px' } }>
                        <ColLabel sm={ 2 }>
                          <Label>{ `Approver's Remark` }</Label>
                        </ColLabel >
                        <ColRemark sm={ 9 }>
                          <TextInfo>{get(last_submit_request, 'remark_approver')}</TextInfo>
                        </ColRemark>
                      </Row>
                    }
                    <br />
                    <br />
                    {
                      (canEdit || [CONSTANTS.DONE, CONSTANTS.INACTIVE].includes(project_status)) && activeToggle === 1 &&
                      <WrapperButton>
                        <Button
                          theme='#28a745'
                          width='160px'
                          height='26px'
                          onClick={ get(this.props, 'clickChangeStatus') }
                        >
                          Change Project Status
                        </Button>

                        { ![CONSTANTS.DONE, CONSTANTS.INACTIVE].includes(project_status) && !editProjectInfo &&
                        <Button
                          theme='#28a745'
                          icon={ <FaRegEdit style={ { fontSize: 16 } } /> }
                          width='70px'
                          height='26px'
                          style={ { marginLeft: 12 } }
                          onClick={ () => this.props.clickEdit() }
                        >
                          Edit
                        </Button>
                        }
                        { editProjectInfo &&
                        // <SaveWrapper disabled={ invalid }>
                          <Button
                            theme='#28a745'
                            icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
                            width='70px'
                            height='26px'
                            style={ { marginLeft: 12 } }
                            // disabled={ invalid }
                            onClick={ () => this.props.editProjectInformation(this.state) }
                          >
                            Save
                          </Button>
                        //   <div id='tooltip'>Please recheck the required field in project information details</div>
                        // </SaveWrapper>
                        }
                        { editProjectInfo &&
                        <Button
                          theme='#6c757d'
                          width='70px'
                          height='26px'
                          style={ { marginLeft: 12 } }
                          onClick={ () => {
                            this.setState({ projectByID: null })
                            this.props.cancelEdit('editProjectInfo')
                          } }
                        >
                          Cancel
                        </Button>
                        }
                      </WrapperButton>
                    }
                    { canApproverOrReject &&
                      <WrapperButton>
                        <Button
                          theme='#D44B49'
                          width='130px'
                          height='26px'
                          onClick={ () => this.props.clickApproveOrReject('Reject') }
                        >
                          Reject Project
                        </Button>
                        <Button
                          theme='#28a745'
                          width='130px'
                          height='26px'
                          style={ { marginLeft: 12 } }
                          onClick={ () => this.props.clickApproveOrReject('Approve') }
                        >
                          Approve Project
                        </Button>
                      </WrapperButton>
                    }
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </div>
      </Wrapper>
    )
  }
}

ProjectInformationTable.propTypes = {
  editProjectInformation: PropTypes.func,
  clickEdit: PropTypes.func,
  cancelEdit: PropTypes.func,
  clickApproveOrReject: PropTypes.func,
}
ProjectInformationTable.defaultProps = {
  editProjectInformation: () => {},
  clickEdit: () => {},
  cancelEdit: () => {},
  clickApproveOrReject: () => {},
}

const mapStateToProps = (state, props) => createStructuredSelector({
  authData: authSelector.getAuth,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(ProjectInformationTable)

const WrapperButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;
`

const Wrapper = styled.div`
  margin-top: 16px;
  font-family: ${FONTS.GOTHAM};
  margin-bottom: 30px;
  font-size: ${FONTS.SMALL_SIZE};
`

const TextInfo = styled.span`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`

const ColRemark = styled(Col)`
  background-color:#EBEBEB;
  padding: 1%;
`

const ColLabel = styled(Col)`
  padding: 1%;
`

const Icon = styled.img`
  width : 10px ;
  height : 10px;
  margin-left: 1%;
  margin-right: 1%;
  cursor: pointer;
`

const Container = styled.div`
  padding-left: 2%;
  padding-top: 2%;
  padding-right: 10%;
  background: #F9F9F9;
  color: black;
  border: 1px solid #CCCCCC ;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
`

const Header = styled.div`
  height: 50px;
  background: #404040;
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  display: flex;
  align-items: center;
  cursor: pointer;
`

const CustomInputField = styled(CustomInput)`
  font-family: ${FONTS.GOTHAM} !important;
  width : 100% ;
  height : 100% ;
  font-size: ${FONTS.SMALL_SIZE};
`

const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`

const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;

  ${p => p.required && `
    ::after {
      content: '*';
      color: red;
    }
  `}
`

const CenterLabelWrapper = styled(LabelWrapper)`
  justify-content: center;
`

const DropdownLabel = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
`

const DropdownWrapper = styled.div`
  flex: 2;
`

const FlexWrapper = styled.div`
  flex: ${p => (p.flex || 1)};
`

// const SaveWrapper = styled.div`
//   position: relative;

//   #tooltip {
//     max-width: 300px;
//     position: absolute;
//     left: -200px;
//     top: -60px;
//     padding: 8px 12px;
//     background: #FFFFFF;
//     border: 1px solid #EAEAEA;
//     box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
//     border-radius: 4px;
//     color: #808080;
//     font-family: ${FONTS.GOTHAM};
//     font-size: ${FONTS.SMALL_SIZE};
//     transition: opacity 0s ease;
//     opacity: 0;
//     visibility: hidden;
//   }

//   :hover {
//   ${p => (p.disabled && `
//     #tooltip {
//       transition: opacity 0s ease;
//       opacity: 1;
//       visibility: visible;
//     }
//     `)}
//   }
// `



// WEBPACK FOOTER //
// ./src/components/project-information/table/table-overview/table-project-information.js